<template>
	<section class="main-content contentblock-section">
		<div class="row">
			<slot name="header" />
		</div>
		<alternating-block v-for="block in items" :key="block.ID" class="row block-item reverse">
			<div class="columns column6">
				<picture>
					<source :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
				</picture>
			</div>
			<div class="columns column6 col-content">
				<div class="inner-wrapper">
					<h3>{{ block.header }}</h3>
					<div v-parse-links v-html="block.content" />
				</div>
			</div>
		</alternating-block>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblock-section {
	padding: 50px 0 100px;
	background: var(--footer-background-color);

	&:last-child {
		margin-bottom: 2px;
	}

	.column6 {
		padding: 0;
		display: flex;
		flex-flow: row wrap;
		justify-content: flex-start;
		align-items: center;
	}

	.inner-wrapper {
		display: flex;
		flex-flow: row wrap;
		justify-content: flex-start;
		align-items: center;
		padding: 60px 40px;
	}

	.col-content {
		background: #b2b7a633;
		color: var(--primary-background-color);
		padding: 0 20px;
	}

	img,
	picture {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.contentblock-section.index {
	background: var(--footer-background-color);

	.row:first-child {
		max-width: 400px;
		margin: 0 auto 50px;
	}
}

@media (max-width: 600px) {
	.block-item {
		padding: 0 20px;
	}

	.contentblock-section {
		padding: 50px 0;
	}

	.contentblock-section .inner-wrapper {
		padding: 30px 5px;
	}
}
</style>
